import Decimal from "decimal.js";

export function formatCurrency(value: number | string | Decimal | null | undefined, decimals: number = 2): string {
    if (value == null) return '-';
    let num: number;
    if (typeof value === 'string') {
        num = Number(value);
    } else if (typeof value === 'number') {
        num = value;
    } else {
        num = Number(value.toFixed(decimals));
    }
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
}
